export default function () {
  return [
    {
      title: '开始时间',
      [$field]: 'startDate',
      isEdit: true,
      width: 150,
      props: {
        type: 'date'
      },
      showType: 'datePicker'
    },
    {
      title: '结束时间',
      [$field]: 'endDate',
      isEdit: true,
      width: 150,
      props: {
        type: 'date'
      },
      showType: 'datePicker'
    },
    {
      title: '学习/工作单位',
      isEdit: true,
      [$field]: 'unitName'
    },
    {
      title: '职务/岗位',
      isEdit: true,
      [$field]: 'postName'
    },
    {
      'title': '操作',
      'width': 120,
      [$field]: 'operate',
      'isOperate': true
    }
  ]
}
